module.exports = __webpack_public_path__ + "img/no_data.f933f7cf.svg";